const base = '/user',
    basePath = `pages${base}`;
export default [
    {
        path:`/user/info`,
        name:'userInfo',
        component:r => require.ensure([], () => r(require(`@/${basePath}/info`)), 'userInfo'),
        meta:{
            tit:'我的信息'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/router/user.js